import { PlusIcon } from "@heroicons/react/solid";
import { useState } from "react";
import { useSelector } from "react-redux";
import Customer from "@/redux/models/Customer";
import AddressSelector from "@/components/checkout/address/AddressSelector";
import { CreateOrUpdateAddressForm } from "@/components/checkout/address/CreateOrUpdateAddressForm";

const ProfileAddressSection = () => {
  const locations = useSelector(Customer.selectors.getCustomerLocations);
  const [isAddingAddress, setIsAddingAddress] = useState(!locations.length);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const addressFormVisible = isAddingAddress || isEditingAddress;
  const [selectedAddress, setSelectedAddress] = useState(
    locations.find((l) => l.default) || locations[0]
  );

  const onChangeSelected = async (newAddress) => {
    setSelectedAddress(newAddress);
    if (!newAddress) {
      setIsAddingAddress(true);
    }
  };

  return (
    <div>
      <div className="flex justify-between rounded-md">
        <div className="flex items-center my-3">
          <span className="font-semibold text-lg font-poppins">Shipping Address</span>
        </div>
        {!addressFormVisible && (
          <button
            className="flex items-center gap-1 text-base link"
            onClick={() => setIsAddingAddress(true)}
          >
            <PlusIcon className="w-4 h-4" />
            Add address
          </button>
        )}
      </div>
      {addressFormVisible ? (
        <CreateOrUpdateAddressForm
          selectedAddress={selectedAddress}
          setSelectedAddress={onChangeSelected}
          onCancel={() => {
            setIsAddingAddress(false);
            setIsEditingAddress(false);
          }}
          isCreateMode={isAddingAddress}
        />
      ) : (
        <AddressSelector
          selected={selectedAddress}
          setSelected={onChangeSelected}
          setIsEditing={() => setIsEditingAddress(true)}
        />
      )}
    </div>
  );
};

export default ProfileAddressSection;
